// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    productAddToCartButtonStyles,
    productAddToCartIconButtonStyles,
    productAddToCartLinkStyles,
} from "@eisinc/Overrides/Components/ProductAddToCartButton";
import { color } from "@eisinc/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

productAddToCartIconButtonStyles.sizeVariant = "small";

productAddToCartIconButtonStyles.css = css`
    text-transform: uppercase;
    padding: 0 8px;
    width: 34px;
    min-width: 34px;
    justify-content: center;
    &.loading,
    &.success {
        padding: 0 8px;
    }
    ${ButtonIcon} {
        margin-left: 0;
        margin-right: 0;
        width: fit-content;
        ${IconWrapper} {
            margin: 0;
            top: 0;
            width: 18px;
            height: 16px;
        }
        > svg {
            width: 18px;
            height: 16px;
        }
    }
`;

productAddToCartLinkStyles.addToCartClickable = {
    css: css`
        &:hover,
        &:focus {
            .as-link-icon {
                color: ${color("text.main")};
            }

            .as-link-text {
                text-decoration: underline;
            }
        }
    `,
};

productAddToCartLinkStyles.linkIconTextWrapper = {
    css: css`
        display: flex;
        align-items: center;
        line-height: 1;
    `,
};

productAddToCartLinkStyles.linkIcon = {
    size: 13,
    color: "primary.main",
    css: css`
        transition: all 200ms ease-in-out;
    `,
};

productAddToCartLinkStyles.linkText = {
    color: "text.main",
    size: "14px",
    lineHeight: "10px",
    css: css`
        margin-left: 6.5px;
        transition: all 200ms ease-in-out;
    `,
};

productAddToCartButtonStyles.css = css`
    text-transform: uppercase;
    color: ${color("common.ui1")};
`;
